import { trackEvent } from './analytics';

// Track user journey through conversion funnel
export const trackFunnelStep = (step, metadata = '') => {
  const funnelSteps = {
    'landing_view': 'Step 1: Landing Page View',
    'offers_view': 'Step 2: Viewed Offers',
    'offer_detail': 'Step 3: Clicked Offer Detail',
    'signup_start': 'Step 4: Started Signup',
    'signup_complete': 'Step 5: Completed Signup',
    'first_offer_click': 'Step 6: Clicked First Offer',
    'payout_request': 'Step 7: Requested Payout'
  };

  trackEvent('funnel_step', 'Conversion Funnel', `${step}|${metadata}`);
  console.log(`🎯 Funnel: ${funnelSteps[step] || step}`);
};

// Track drop-off points
export const trackDropOff = (location, reason = '') => {
  trackEvent('user_drop_off', 'Engagement', `${location}|${reason}`);
};